import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import LeadInfoCardTheme1 from "./LeadInfoCardTheme1";
import { leadCard1Object } from "./ExportLeadInfoCard1Object";
import EditorLeadForm from "./EditorLeadForm";
import { useDispatch } from "react-redux";

const LeadFormBuilder =({})=>{
         const [leadInfoCard1Object, setleadThemeCard1Object]=useState(leadCard1Object)
          const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
const [ showLeftQueBar, setShowLeftQueBar] = useState(true);

const [ statusVal, setStatusVal] = useState(false);




    return (<>
       <div   className="AreYouSurePopUpFive" style={{borderRadius: '0px',border:"0px solid #fff",background:"rgb(244, 253, 255)"}}>
             

      {!showLeftQueBar? <div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",left:"0px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",zIndex:99999,cursor:"pointer"}} onClick={()=>setShowLeftQueBar(true)} ><ChevronRight size={22}  color="rgb(86, 82, 131)"/></div> 
:""}

 <div   className={!showLeftQueBar? "":"QuestionDashboardPopUpRight"} style={{borderRadius: '0px',border:"0px solid #fff",background:"rgb(244, 253, 255)"}}>
   

   
    {showLeftQueBar? <div   className="QuestionDashboardPopUpLeft " style={{borderRadius: '0px',border:"0px solid #fff",background:"rgb(244, 253, 255)"}}> 
             <div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"15px",zIndex:99999,cursor:"pointer"}} onClick={()=>setShowLeftQueBar(false)} ><ChevronLeft size={22}  color="rgb(86, 82, 131)"/></div> 

 <div  >
<EditorLeadForm 
  leadThemeObject={leadInfoCard1Object} 
  setLeadObjectImageFields={(field,subField, value) => {
    setleadThemeCard1Object((prev) => ({
      ...prev,
      image: { 
         ...prev.image, 
         [field]: { 
        ...prev[field],   // keep title, status, etc.
        [subField]:value             // update/add value
      }           // update/add value
      }
    }));
  }}  
  setLeadObjectFields={(field,subField, value) => {
    setleadThemeCard1Object((prev) => ({
      ...prev,
      [field]: { 
        ...prev[field],   // keep title, status, etc.
        [subField]:value             // update/add value
      }
    }));
  }}  

  setActiveSettingBack={(val)=>{
    if(val=="CTA"){ setStatusVal(true)}
      if(val=="contents"){ setStatusVal(false)}
  }}

  activeSettingBack={statusVal} 
/> 
   </div>
   
   </div>:""} 
    <div style={{padding:"10px",}}><h2> Lead Form </h2></div>
    <div style={{overflowY:"auto",height:"70vh"}}>
     <LeadInfoCardTheme1 status={statusVal} setStatus={(val)=>{val?setStatusVal(true):setStatusVal(false)}} leadThemeObject = {leadInfoCard1Object} />
      </div>
   
   
   </div> 
    </div> 


     <style>{ `
   
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
}
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
}
/* xs */
@media (max-width: 767px) {
  
}
        `}
        </style>
    </>) 
}

export default LeadFormBuilder;